<template>
  <div class="mb-16">
    <h2 class="custom-title custom-color-gray font-medium mb-4">
      {{
        $t(
          'message.publishDocuments.configGenericPublish.checkNotificationMail.question'
        )
      }}
    </h2>
    <p class="custom-legend text-zt-dark-300 mb-4">
      {{
        $t(
          'message.publishDocuments.configGenericPublish.checkNotificationMail.description'
        )
      }}
    </p>
    <zt-check-box ref="ztCheckbox" fill v-model="statePublish.documentNotification"
      >{{
        $t(
          'message.publishDocuments.configGenericPublish.checkNotificationMail.label'
        )
      }}
    </zt-check-box>
  </div>
</template>

<script>
export default {
  name: 'checkNotificationMail',
  inject: ['statePublish'],
  data() {
    return {}
  }
}
</script>

<style scoped lang="css">
.custom-color-gray {
  color: #575757;
}
.custom-title {
  font-size: 1.5rem;
}
.custom-legend {
  font-size: 1.125rem;
}
</style>
